module.exports = __webpack_public_path__ + "static/media/judge.eccf4698.svg";